// ============================================================
// HABIT OS — Bibliothek: Supplement-Timing & Absorption
// Wann, wie und warum — nicht nur was.
// ============================================================

export const LIBRARY_SUPPLEMENTS = {
  id: "supplements",
  label: "Supplement-Timing & Absorption",
  icon: "💊",
  subcategories: [

    // ── MORGEN-PROTOKOLL ─────────────────────
    {
      id: "suppl_morning",
      label: "Morgen-Protokoll (Nüchtern)",
      icon: "🌅",
      habits: [
        {
          id: "hab_suppl_inflammation_shot",
          label: "Olivenöl-Zitronen-Shot (06:05 Uhr)",
          time: "morning",
          icon: "🫒",
          why: "Natives Olivenöl extra enthält Polyphenole, Zitronensaft liefert Vitamin C. Vitamin C trägt zu einer normalen Funktion des Immunsystems bei.",
          source: "Beauchamp et al., Nature, 2005 · Cicerale et al., Journal of Agricultural and Food Chemistry, 2010",
          dose: "1 EL kaltgepresstes natives Olivenöl Extra (erste Kaltpressung) + Saft 1/2 Bio-Zitrone. Auf ex trinken, nicht sippeln. Danach 5 Min. warten bevor weitere Supplements.",
        },
        {
          id: "hab_suppl_psyllium",
          label: "Flohsamenschalen (06:10 Uhr)",
          time: "morning",
          icon: "🌾",
          why: "Flohsamenschalen sind ein Ballaststoff, der im Darm aufquillt. Immer reichlich Wasser dazu trinken; bei Diabetes oder Medikamenteneinnahme vorher ärztlich abklären.",
          source: "Anderson et al., American Journal of Clinical Nutrition, 2009 · Gibb et al., American Journal of Clinical Nutrition, 2015",
          dose: "Laut Herstellerangabe in 300ml Wasser — sofort rühren und SOFORT trinken. Danach 300ml Wasser nachspülen. Mindestens 30 Min. Abstand zu anderen Supplements (reduziert deren Absorption).",
        },
        {
          id: "hab_suppl_vitamin_d3k2",
          label: "Vitamin D3 + K2 mit Fett (06:15 Uhr)",
          time: "morning",
          icon: "☀️",
          why: "Vitamin D ist fettlöslich und wird mit einer fetthaltigen Mahlzeit besser aufgenommen. Es trägt zur Erhaltung normaler Knochen bei.",
          source: "Dawson-Hughes et al., Journal of Clinical Endocrinology, 2020 · Schurgers et al., Blood, 2007",
          dose: "Laut Herstellerangabe zu einer fetthaltigen Mahlzeit. Mehr als 20 µg (800 IE) täglich nur nach Bluttest und ärztlicher Rücksprache.",
        },
      ],
    },

    // ── POST-WORKOUT ─────────────────────────
    {
      id: "suppl_post_workout",
      label: "Post-Workout Fenster",
      icon: "💪",
      habits: [
        {
          id: "hab_suppl_creatine_timing",
          label: "Kreatin: täglich zur festen Zeit",
          time: "morning",
          icon: "⚡",
          why: "Entscheidend ist die regelmäßige tägliche Einnahme. Kreatin erhöht die körperliche Leistung bei kurzzeitigen intensiven Belastungen (ab 3 g täglich).",
          source: "Antonio & Ciccone, Journal of the International Society of Sports Nutrition, 2013 · Candow et al., Nutrients, 2021",
          dose: "Kreatin-Monohydrat täglich laut Herstellerangabe, Zeitpunkt flexibel.",
        },
        {
          id: "hab_suppl_whey_timing",
          label: "Whey Isolat: Das 30-Minuten-Fenster",
          time: "morning",
          icon: "🥛",
          why: "Whey liefert nach dem Training schnell verfügbares Eiweiß. Protein trägt zu einer Zunahme und Erhaltung von Muskelmasse bei.",
          source: "Raastad et al., European Journal of Applied Physiology, 2000 · Norton & Layman, Journal of Nutrition, 2006",
          dose: "Eine Portion Whey Isolat laut Herstellerangabe innerhalb von etwa einer Stunde nach dem Training.",
        },
        {
          id: "hab_suppl_cinnamon_insulin",
          label: "Ceylon-Zimt im Shake oder zum Frühstück",
          time: "morning",
          icon: "🌿",
          why: "Ceylon-Zimt enthält deutlich weniger Cumarin als Cassia-Zimt. Bei Diabetes oder blutzuckersenkenden Medikamenten vorher ärztlich abklären.",
          source: "Kirkham et al., Diabetes, Obesity and Metabolism, 2009 · Davis & Yokoyama, Journal of Medicinal Food, 2011",
          dose: "1 TL Ceylon-Zimt in den Shake oder morgens in Kaffee/Joghurt.",
        },
      ],
    },

    // ── MITTAG & NACHMITTAG ──────────────────
    {
      id: "suppl_midday",
      label: "Mittag & Nachmittag",
      icon: "🌞",
      habits: [
        {
          id: "hab_suppl_papaya_seeds",
          label: "Getrocknete Papayakerne (nach Mittagessen)",
          time: "flexible",
          icon: "🌴",
          why: "Papayakerne schmecken pfeffrig-scharf und können als Gewürz verwendet werden. In Schwangerschaft und Stillzeit meiden.",
          source: "Amazu et al., Asian Pacific Journal of Tropical Medicine, 2009 · Okeniyi et al., Journal of Medicinal Food, 2007",
          dose: "Gelegentlich wenige Kerne als Gewürz verwenden.",
        },
        {
          id: "hab_suppl_omega3_timing",
          label: "Omega-3: Mit der fettreichsten Mahlzeit",
          time: "flexible",
          icon: "🐟",
          why: "Omega-3 Fettsäuren (EPA + DHA) sind fettlöslich — ihre Absorption steigt um bis zu 300% wenn sie mit einer fettreichen Mahlzeit eingenommen werden. Der Trick: nicht morgens nüchtern nehmen. Triglycerid-Form (natürlicher Fischöl) wird besser absorbiert als Ethylester-Form (billiges Fischöl). Re-esterifiziertes Triglycerid (rTG) ist die beste Form. Enteric-coated Kapseln reduzieren Fischaufstoßen. EPA reduziert Entzündung, DHA ist strukturell für Gehirn und Augen.",
          source: "Dyerberg et al., Prostaglandins, Leukotrienes and Essential Fatty Acids, 2010",
          dose: "Laut Herstellerangabe zur fettreichsten Mahlzeit.",
        },
        {
          id: "hab_suppl_zinc_timing",
          label: "Zink: Nicht mit Eisen oder Kalzium kombinieren",
          time: "flexible",
          icon: "🔬",
          why: "Zink, Eisen und Kalzium können sich bei gleichzeitiger Einnahme in der Aufnahme behindern.",
          source: "Sandström & Lönnerdal, American Journal of Clinical Nutrition, 1989",
          dose: "Laut Herstellerangabe, mit 2 Stunden Abstand zu Eisen- und Kalziumpräparaten.",
        },
      ],
    },

    // ── ABEND-PROTOKOLL ──────────────────────
    {
      id: "suppl_evening",
      label: "Abend & Schlaf-Protokoll",
      icon: "🌙",
      habits: [
        {
          id: "hab_suppl_magnesium_night",
          label: "Magnesium Bisglycinat (22:30 Uhr)",
          time: "night",
          icon: "🌙",
          why: "Magnesium-Bisglycinat ist eine gut verträgliche Magnesiumform. Magnesium trägt zu einer normalen Funktion des Nervensystems und der Muskeln bei.",
          source: "Abbasi et al., Journal of Research in Medical Sciences, 2012 · Wienecke & Nolden, MMW Fortschritte der Medizin, 2016",
          dose: "Laut Herstellerangabe am Abend.",
        },
        {
          id: "hab_suppl_black_seed_oil",
          label: "Schwarzkümmelöl (22:30 Uhr)",
          time: "night",
          icon: "🌱",
          why: "Schwarzkümmelöl ist ein traditionelles Speiseöl mit würzigem Geschmack.",
          source: "Ahmad et al., Asian Pacific Journal of Tropical Biomedicine, 2013 · Datau et al., Acta Medica Indonesiana, 2010",
          dose: "1 TL (5ml) kaltgepresstes Schwarzkümmelöl abends. Pur schlucken oder in Honig einrühren. Kalt lagern, lichtgeschützt.",
        },
        {
          id: "hab_suppl_collagen_night",
          label: "Kollagen + Vitamin C vor dem Schlafen",
          time: "night",
          icon: "🦴",
          why: "Kollagen-Peptide liefern Eiweiß mit hohem Glycin-Anteil. Vitamin C trägt zu einer normalen Kollagenbildung bei.",
          source: "Shaw et al., American Journal of Clinical Nutrition, 2017 · Kumar et al., Journal of Aging Research, 2015",
          dose: "Kollagen-Peptide und Vitamin C laut Herstellerangabe, 30–60 Min. vor dem Schlafen. In warmem Wasser oder Kräutertee auflösen.",
        },
      ],
    },

    // ── SUPPLEMENT-SYNERGIEN & ANTAGONISTEN ──
    {
      id: "suppl_synergies",
      label: "Synergien & Fehler vermeiden",
      icon: "⚗️",
      habits: [
        {
          id: "hab_suppl_fat_soluble",
          label: "Fettlösliche Vitamine: Immer mit Fett",
          time: "flexible",
          icon: "🧈",
          why: "Vitamine A, D, E und K sind fettlöslich — ohne gleichzeitige Fettzufuhr beträgt die Absorption unter 10–30%. Mit einer fettreichen Mahlzeit steigt sie auf 70–90%. Häufiger Fehler: Vitamin D morgens nüchtern nehmen. Lösung: Immer mit Avocado, Olivenöl, Nüssen oder Eiern kombinieren. Besonders kritisch bei D3+K2 da beide fettlöslich sind und auf denselben Transportmechanismus angewiesen.",
          source: "Dawson-Hughes et al., Journal of the Academy of Nutrition and Dietetics, 2015",
          dose: "Vitamin A, D, E, K immer zu einer Mahlzeit mit mindestens 10–15g Fett einnehmen. Morgens mit Eiern, mittags mit Olivenöl-Dressing, abends mit Nüssen.",
        },
        {
          id: "hab_suppl_iron_enemies",
          label: "Eisen-Feinde: Kaffee, Tee & Kalzium",
          time: "flexible",
          icon: "☕",
          why: "Eisen-Absorption wird massiv reduziert durch: Kaffee (-39%), schwarzer Tee (-64%), grüner Tee (-27%), Kalzium (-50%), Phytate in Getreide (-82%). Vitamin C hingegen erhöht die Nicht-Häm-Eisen-Absorption um 300–600%. Häufiger Fehler: Eisen-Supplement mit Morgenkaffee nehmen. Lösung: Eisen auf nüchternen Magen mit Orangensaft oder mindestens 1 Stunde vor/nach Kaffee und Milchprodukten.",
          source: "Hurrell et al., British Journal of Nutrition, 1999 · Hallberg et al., American Journal of Clinical Nutrition, 1989",
          dose: "Eisenpräparate nur bei ärztlich festgestelltem Mangel und nach ärztlicher Anweisung.",
        },
        {
          id: "hab_suppl_timing_mistakes",
          label: "Die 5 häufigsten Timing-Fehler",
          time: "flexible",
          icon: "❌",
          why: "Zink, Eisen und Kalzium besser zeitversetzt, fettlösliche Vitamine zu einer Mahlzeit einnehmen.",
          source: "Functional Medicine Institute · Nutrient Interaction Database",
          dose: "Nährstoffe laut Herstellerangabe einnehmen.",
        },
      ],
    },
  ],
};